import React, {useRef, useState} from "react";
import Header from "../components/Header";
import Contact from "../components/Contact";
import ChatInput from "../components/ChatInput";
import Slider from "react-slick";
import {FullpageContainer, FullpageSection,} from '@shinyongjun/react-fullpage';
import '@shinyongjun/react-fullpage/css';


function Main() {
    // 아코디언 클릭 시 열거나 닫는 처리
    const [activeIndex, setActiveIndex] = useState(0); // 아코디언 상태
    const [accordionActiveIndex, setAccordionActiveIndex] = useState(null);

    // 아코디언 클릭 시 열거나 닫는 처리
    const handleAccordionClick = (index) => {
        setAccordionActiveIndex((prev) => (prev === index ? null : index));

    };

    const sliderRef = useRef(null);

    const sliderSettings = {
        centerMode: false,
        slidesToShow: 4,
        arrows: false,
        dots: true,
        infinite: true,
        swipeToSlide: true,  // << 이거 추가!!
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                },
            },
        ],
    };

    const settings = {
        centerMode: true,
        infinite: false,
        centerPadding: '0',
        slidesToShow: 4 ,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    centerMode: true,
                    centerPadding: '30px',
                    slidesToShow: 1,
                },
            },
        ],
    };
    const faq_settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const handlePrevClick = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
        }
    };

    const handleNextClick = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext();
        }
    };
    return(

        <div id="outer">
            <div id="parallax-bg"   style={{
                backgroundImage: "url('/img/upscaleBackground2.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "repeat",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "120vh",
                zIndex: -1,
                transform: "translateY(0)",
                willChange: "transform",
                opacity: 0.9,

            }}></div>
            <div id="loadingSpinner">
                <img src="/img/loading.svg" alt="로딩 중..."/>
            </div>
            <main id="content-box" className="order-first">
                {/* 로고 영역 */}
{/*                <a href="http://localhost:3000">
                    <div className="navbar-logo" style={{ textAlign: "left" }}>
                        <img src="/img/logo.png" alt="Logo" style={{ width: "218px" }} />
                    </div>
                </a>*/}
                <Header setActiveIndex={setActiveIndex} activeIndex={activeIndex}></Header>
                <FullpageContainer
                    activeIndex={activeIndex}
                    setActiveIndex={setActiveIndex}>
                    <FullpageSection>

                        <div className="banner-section section parallax-window" data-parallax="scroll"
                             data-image-src="img/background.png" id="section-1">
                            <div className="container">
                                <div className="hero-wrapper">
                                    <div className="hero-card">
                                        <div className="hero-icon">
                                            <i className="fas fa-atom fa-2x"></i>
                                        </div>
                                        <h1> Refine My Knowledge <br/>
                                            Master My Experience <br/>
                                            Compose My Data</h1>
                                        <p>내 지식을 정제하고, 내 경험을 숙달하며, 내 데이터를 지배하다.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FullpageSection>
                    <FullpageSection>
                        <section className="work-section section parallax-window" id="section-2">
                            <div className="container">
                                <div className="title text-right">
                                    <h2>기능</h2>
                                </div>
                                <div className="gallery-slider-wrapper">
                                    <Slider {...settings}>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>정보 관리 및 검색</h3>
                                                <p>빠른 정보 검색과 추론이 가능합니다.
                                                    저장된 문서를 기반으로 필요한 정보를 즉시 찾아 제공합니다.</p>
                                                <img src="img/answer.png" alt="Card1"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>지식 및 인사이트 제공</h3>
                                                <p>문서 내용 요약 및 분석하고, 중요한 내용을 추출하고 핵심을 파악합니다.</p>
                                                    <p>데이터 기반 결과 도출
                                                    문서 속 숨겨진 패턴과 트렌드를 분석해 유용한 정보를 제공합니다</p>
                                                <img src="img/insight.png" alt="Card2"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>업무 자동화 및 지원</h3>
                                                <p>스마트 알람 : 문서와 연계된 일정으로 알림 설정을 제공합니다.</p>
                                                <p>맞춤형 추천,  의사결정 지원  – 사용자의 다양한 업무에 맞춘 정보 추천 및 의사결정 도움.  </p>
                                                <img src="img/auto.png" alt="Card3"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>보안 및 개인화</h3>
                                                <p>데이터의 보호 - 문서를 AI스토리지에 안전하게 저장합니다.</p>
                                                <p>사용자 맞춤형 AI  – 개인화된 검색 방식과 추천 기능을 학습하여 좀 더 사용자가 원하는 더 가까운 응답을 제공합니다.</p>
                                                <img src="img/security.png" alt="Card3"/>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                        </section>
                    </FullpageSection>
                    <FullpageSection>
                        <section
                            className="gallery-section section parallax-window"
                            data-parallax="scroll"
                            data-image-src="img/background.jpg"
                            id="section-3">
                            <div className="container">
                                <div className="title text-right">
                                    <h2>보안정책</h2>
                                </div>

                                <div className="gallery-slider-wrapper">
                                    <Slider {...sliderSettings}>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>데이터 암호화</h3>
                                                <p>저장 및 전송되는 모든 문서는 openAi의 강력한 암호화 기술을 적용하여 보호됩니다.</p>
                                                <img src="img/data_sec.jpg" alt="Card1"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>개인정보 보호 </h3>
                                                <p>사용자의 데이터는 외부와 공유되지 않으며, 철저한 접근 통제 시스템을 적용합니다.</p>
                                                <img src="img/Data_security.jpg" alt="Card2"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>사용자 인증 및 권한 관리</h3>
                                                <p>AI 비서에 접근할 수 있는 사용자 권한을 명확히 설정하고 인증을 적용하여 보안을 강화합니다. </p>
                                                <img src="img/login-img.jpg" alt="Card3"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>AI 모델의 안전성 검토</h3>
                                                <p>OpenAI의 최신 보안 가이드라인을 준수하며 AI의 응답을 검토하는 시스템을 구축합니다. </p>
                                                <img src="img/Ai_img.jpg" alt="Card4"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>데이터 삭제 및 제어</h3>
                                                <p>사용자가 원할 경우 자신의 데이터를 완전히 삭제할 수 있으며, AI가 불필요한 정보를 저장하지 않도록 설계됩니다.  </p>
                                                <img src="img/data_control.jpg" alt="Card5"/>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="gallery-card">
                                                <h3>보안 인증 및 법규 준수</h3>
                                                <p>GDPR, ISO 27001 등의 국제 보안 규정을 준수하여 신뢰성을 확보합니다.</p>
                                                <img src="img/auth.jpg" alt="Card6"/>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                        </section>
                    </FullpageSection>

                    <FullpageSection>
                        <section className="gallery-section section  parallax-window" data-parallax="scroll"
                                 id="section-4">
                            <div className="gallery-slider-wrapper">
                            <Slider {...faq_settings}>
                                <div>
                                    <div className="faq-container">
                                        <h2 className="faq_h2">Ahri 관련 자주 묻는 질문</h2>
                                        <div className="faq_dec">업무 방식을 <br/> <strong>획기적으로</strong><br/> 바꿀 스마트한 도구</div>
                                        <div className="accordion">
                                            <div className={`accordion-item ${accordionActiveIndex === 1 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(1)}
                                                >
                                                    BNS Ahri는 어떤 방식으로 정보를 검색하나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>저장된 문서와 웹검색을 활용해 빠르고 정확하게 필요한 정보를 제공합니다.
                                                        사용자가 폴더별로 정리된 문서들을 한군데 모아두고 그 폴더를 한개 또는 여러개 선택하여 해당 폴더 내에서 질문에 대한 답을 찾게 됩니다. </p>
                                                </div>
                                            </div>

                                            <div className={`accordion-item ${accordionActiveIndex === 2 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(2)}
                                                >
                                                    AI가 제공하는 인사이트는 어떤 기준으로 추출되나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>선택한 폴더에 있는 문서들의 패턴을 분석하고, 그 데이터 기반으로 핵심 내용을 도출해 유용한 정보를 제공합니다.</p>
                                                </div>
                                            </div>

                                            <div className={`accordion-item ${accordionActiveIndex === 3 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(3)}
                                                >
                                                    맞춤형 추천 기능은 어떻게 작동하나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>사용자의 검색 및 문서 활용 패턴을 대화창이 유지되는 동안 같은 방법으로 학습하여 개인화된 정보를 제공하고 의사결정을 지원합니다.</p>
                                                </div>
                                            </div>
                                            <div className={`accordion-item ${accordionActiveIndex === 4 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(4)}
                                                >
                                                    홈페이지에서 시연하는 방법과 동일한 기능을 제공하나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>홈페이지의 시연방법은 간단히 문서를 미리 업로드하고 해당 문서 내에서 내용을 검토하는 범위만들 데모로 보여드립니다. 실제 제품은 더 직관적인 파일탐색기와 멀티대화창 및 웹검색 등을 지원하므로, 좀 더 업무에 효율적으로 사용할 수 있습니다.</p>
                                                </div>
                                            </div>
                                            <div className={`accordion-item ${accordionActiveIndex === 5 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(5)}
                                                >
                                                    상품을 먼저 사용해 볼 수 있나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>아래의 링크로 사용신청 해 주시면, 신청하신 메일로 시연용 테스트계정을 보내드립니다.
                                                        ( 구글폼 연동 : 회사명(학교명), 성명, 이메일, 이 상품의 적용분야)</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="faq-container">
                                        <h2 className="faq_h2">Ahri 관련 자주 묻는 질문</h2>
                                        <div className="faq_dec">업무 방식을 <br/> <strong>획기적으로</strong><br/> 바꿀 스마트한 도구</div>
                                        <div className="accordion">
                                            <div className={`accordion-item ${accordionActiveIndex === 1 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(1)}
                                                >
                                                    내 데이터는 안전하게 보호되나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>모든 문서는 OpenAI의 강력한 암호화 기술을 적용해 저장되며, 외부 공유 없이 보호됩니다. </p>
                                                </div>
                                            </div>

                                            <div className={`accordion-item ${accordionActiveIndex === 2 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(2)}
                                                >
                                                    AI는 내 문서 내용을 어떻게 관리하나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>사용자가 직접 문서를 삭제하거나 관리할 수 있으며, AI는 불필요한 정보를 저장하지 않습니다.
                                                        또한 각 폴더별로도 삭제할 수 있기 때문에 다량의 파일을 관리하는데 특별한 경험을 선사합니다.</p>
                                                </div>
                                            </div>

                                            <div className={`accordion-item ${accordionActiveIndex === 3 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(3)}
                                                >
                                                    AI와 대화한 내용들은 어떻게 관리하나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>모든 대화는 상품에 따라 서버 또는 사용자의 단말기에 안전하게 저장되고, 필요에 따라 대화의 전체 또는 일부를 삭제할 수 있습니다. 대화가 삭제되면 공유된 사용자도 해당내용을 삭제되어 보안을 유지할 수 있습니다.</p>
                                                </div>
                                            </div>
                                            <div className={`accordion-item ${accordionActiveIndex === 4 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(4)}
                                                >
                                                    AI 모델의 응답은 어떻게 검토되나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>OpenAI의 최신 보안 가이드라인을 준수하며 AI의 응답을 지속적으로 검토하여 신뢰성을 확보합니다.</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="faq-container">
                                        <h2 className="faq_h2">Ahri 관련 자주 묻는 질문</h2>
                                        <div className="faq_dec">업무 방식을 <br/> <strong>획기적으로</strong><br/> 바꿀 스마트한 도구</div>
                                        <div className="accordion">
                                            <div className={`accordion-item ${accordionActiveIndex === 1 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(1)}
                                                >
                                                    스마트 알람 기능은 어떻게 설정하나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>문서와 연계된 일정에 맞춰 알림을 설정할 수 있으며, 중요한 정보를 자동으로 알려줍니다. 해당 알람은 단말기와 연계하여, 팝업형태 등으로 사용자에게 알려주게 됩니다 </p>
                                                </div>
                                            </div>
                                            <div className={`accordion-item ${accordionActiveIndex === 2 ? 'active' : ''}`}>
                                                <button
                                                    className="accordion-header"
                                                    onClick={() => handleAccordionClick(2)}
                                                >
                                                    AI가 의사결정 지원을 어떻게 제공하나요?
                                                </button>
                                                <div className="accordion-body">
                                                    <p>문서 분석을 통해 최적의 선택지를 제안하고 데이터 기반 의사결정을 돕습니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                            </div>
                        </section>
                    </FullpageSection>
                    <FullpageSection>
                        <section className="gallery-section section parallax-window" data-parallax="scroll"
                                 data-image-src="img/section-3-bg.jpg" id="section-5">
                            <div className="container">
                                <div className="title text-center">
                                    <h2>사용자 리뷰 및 피드백</h2>
                                </div>

                                <div className="testimonial-slider-wrapper">
                                    <button className="arrow arrow-prev" onClick={handlePrevClick}
                                            aria-label="Previous">&#10094;</button>

                                    <div className="testimonial-slider">
                                        <Slider {...sliderSettings} ref={sliderRef}>
                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-01.jpg" alt="김지훈" className="avatar" />
                                                    <div>
                                                        <h4>김지훈 (데이터 분석가)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “예전엔 수십 개의 문서를 직접 열어보면서 필요한 데이터를 하나하나 찾아야 했는데, 이제는 Ahri에 ‘이런 내용이 있는 자료 찾아줘’라고 입력하면 폴더 안의 파일들에서 관련 내용을 추출해 바로 보여줍니다. 패턴 기반 분석은 물론, 문서 간 연결 관계도 파악해줘서 인사이트 도출이 훨씬 쉬워졌어요. 요즘은 프롬프트를 잘 설계해서 더 정교한 결과를 받는 것도 할 수 있어서 좋더라구요.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-02.jpg" alt="이수연" className="avatar" />
                                                    <div>
                                                        <h4>이수연 (스타트업 CEO)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “저희는 외부 시장 동향 파악이 중요해서 Ahri의 웹 검색 기능을 자주 씁니다. ‘최신 업계 동향’ 같은 키워드를 입력하면 관련 기사나 레포트를 AI가 정리해서 보여주니까 회의 준비가 훨씬 수월해졌습니다. 내용의 출처와 함께 필요한 정보만 깔끔하게 정리해줘서 편하게 사용할 수 있었습니다.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-03.jpg" alt="전혜린" className="avatar" />
                                                    <div>
                                                        <h4>전혜린 (마케팅 전문가)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “리서치 업무가 많은 마케팅팀에서는 속도가 곧 경쟁력이에요. Ahri 덕분에 트렌드 관련 보고서를 찾고 요약하는 시간이 눈에 띄게 줄었어요. 예를 들어 ‘최근 Z세대 마케팅 사례 알려줘’라고 하면, 저장된 리포트 파일 안에서 관련 내용을 뽑아내고, 없으면 웹 검색으로도 검색할 수 있어서 곧 도입된다는 파일 탐색기 기능까지 생기면 협업도 더 쉬워질 것 같아요.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-01.jpg" alt="조민석" className="avatar" />
                                                    <div>
                                                        <h4>조민석 (대학생)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “논문 정리할 때 Ahri를 정말 자주 써요. 전공 책이나 논문 PDF가 폴더에 수십 개씩 쌓여 있는데, 그냥 ‘이 논문에서 연구 결과만 알려줘’라고 하면 딱 핵심만 정리해서 보여줘요. 관련 주제의 다른 논문까지 추천해주는 것도 진짜 편하더라구요.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-02.jpg" alt="한지호" className="avatar" />
                                                    <div>
                                                        <h4>한지호 (컨설턴트)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “고객 데이터를 분석할 때 Ahri의 폴더 기반 검색 기능은 정말 효율적이에요. 예전엔 보고서 작성 전에 자료부터 찾느라 시간 반 넘게 썼는데, 지금은 키워드만 입력하면 관련 문서를 자동으로 읽고 핵심 내용을 요약해주죠. 파일을 한번 업로드해놓고 그 내용 기반으로 계속 답변을 주니까 구조적으로 사용할 수 있었어요.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-03.jpg" alt="장유진" className="avatar" />
                                                    <div>
                                                        <h4>장유진 (프리랜서 작가)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “창작 작업을 하다 보면 자료가 여기저기 흩어지기 쉬운데, bns Ahri 덕분에 파일을 한눈에 정리할 수 있어서 작업 효율이 훨씬 좋아졌어요. 자주 찾는 자료를 기억해주고, 관련 정보도 잘 추천해줘서 점점 더 제 스타일에 맞춰주는 느낌이에요.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-01.jpg" alt="오승준" className="avatar" />
                                                    <div>
                                                        <h4>오승준 (프로젝트 매니저)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “스마트 알람 기능이 정말 도움이 많이 됩니다. 일정이 문서랑 자동으로 연결돼 있어서 기한 관리가 훨씬 수월해졌고, 회의 전에 참고 자료도 미리 알려줘서 준비 시간이 줄었어요. 팀원들과 협업할 때도 확실히 편리해졌습니다.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-02.jpg" alt="백지훈" className="avatar" />
                                                    <div>
                                                        <h4>백지훈 (연구원)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “민감한 연구 데이터를 안전하게 관리할 수 있는 점이 마음에 듭니다. 문서 분류나 정리가 체계적으로 잘 되어 있어서 필요한 자료를 쉽게 찾을 수 있고, 논문 분석 기능도 실무에 꽤 유용하게 쓰고 있어요. 연구자에게 딱 맞는 도구라고 생각합니다.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-03.jpg" alt="서현진" className="avatar" />
                                                    <div>
                                                        <h4>서현진 (기업 운영 담당자)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “평소에 처리해야 할 문서가 많은데, Ahri가 문서를 빠르게 분석해서 핵심 내용을 정리해 주는 게 정말 유용해요. 검색도 정확하고, 자주 다루는 업무 스타일을 기억해서 추천 결과가 점점 더 좋아지고 있어요. 업무 결정에도 큰 도움이 됩니다.”
                                                </p>
                                            </div>

                                            <div className="testimonial-card">
                                                <div className="card-header">
                                                    <img src="img/gallery-img-01.jpg" alt="강민수" className="avatar" />
                                                    <div>
                                                        <h4>강민수 (HR 매니저)</h4>
                                                        <span>★★★★★</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    “계약서나 인사 관련 문서를 손쉽게 정리하고 검색할 수 있게 돼서 반복적인 작업이 많이 줄었어요. 특히 Ahri가 자주 찾는 문서를 잘 기억해서 추천해주는 기능이 마음에 들어요. 팀 전체의 문서 활용 효율이 눈에 띄게 높아졌습니다.”
                                                </p>
                                            </div>

                                        </Slider>
                                    </div>

                                    <button className="arrow arrow-next" onClick={handleNextClick}
                                            aria-label="Next">&#10095;</button>
                                </div>
                            </div>
                        </section>
                    </FullpageSection>
                    <FullpageSection>
                        <Contact></Contact>
                    </FullpageSection>
                </FullpageContainer>
                <ChatInput></ChatInput>

            </main>
        </div>
    )
}

export default Main